export const loadOpenedProfileInfoByUserName = username => {
  return {
    type: "LOAD_OPENED_PROFILE_INFO_BY_USERNAME_REQUEST",
    username,
  };
};

export const loadOpenedProfileInfoById = id => ({
  type: "LOAD_OPENED_PROFILE_INFO_BY_ID_REQUEST",
  id,
});

export const loadOpenedProfileInfoSuccess = user => ({
  type: "LOAD_OPENED_PROFILE_INFO_SUCCESS",
  user,
});

export const cleanOpenedProfile = _ => ({
  type: "CLEAN_OPENED_PROFILE",
});

export const loadMoreOpenedProfilePosts = ({ userId, limit = 5, pagingToken, override = false }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_POSTS_REQUEST",
  userId,
  limit,
  pagingToken,
  override,
});

export const loadMoreOpenedProfilePostsSuccess = ({ posts, limit, pagingToken, override }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_POSTS_SUCCESS",
  posts,
  limit,
  pagingToken,
  override,
});

export const cleanOpenedProfilePosts = () => ({
  type: "CLEAN_OPENED_PROFILE_POSTS",
});

export const loadMoreOpenedProfileFollowers = ({ userId, limit = 20, pagingToken, override=false }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_FOLLOWERS_REQUEST",
  userId,
  limit,
  pagingToken,
  override,
});
export const loadMoreOpenedProfileFollowing = ({ userId, limit = 20, pagingToken, override=false }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_FOLLOWING_REQUEST",
  userId,
  limit,
  pagingToken,
  override,
});
export const loadMoreOpenedProfileCollections = ({ userId, limit = 10, pagingToken }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_COLLECTIONS_REQUEST",
  userId,
  limit,
  pagingToken,
});
export const loadMoreOpenedProfileFollowersSuccess = ({ followers, limit, pagingToken, override }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_FOLLOWERS_SUCCESS",
  followers,
  limit,
  pagingToken,
  override,
});
export const loadMoreOpenedProfileFollowingSuccess = ({ following, limit, pagingToken, override }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_FOLLOWING_SUCCESS",
  following,
  limit,
  pagingToken,
  override,
});
export const loadMoreOpenedProfileCollectionsSuccess = ({ collections, limit, pagingToken }) => ({
  type: "LOAD_MORE_OPENED_PROFILE_COLLECTIONS_SUCCESS",
  collections,
  limit,
  pagingToken,
});



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/actions.js